<div style="margin-top: 7px;">
  <p-tabMenu [model]="list" [activeItem]="list[pos]" (itemClick)="selectedIndexChange($event)">
    <ng-template pTemplate="item" let-item let-i="index">
      <div style="position: relative; text-align: center;">
        <div class="p-menuitem-icon" [ngClass]="item.icon" *ngIf="item.icon" style="font-size: 2em"></div>
        <div class="p-menuitem-text">
          {{item.title | translate}}
        </div>
        <span class="pi pi-times" style="position: absolute; right: -10px; top: -9px; padding: 0"
          (click)="_close($event, item)" *ngIf="list.length > 1"></span>
      </div>
    </ng-template>
  </p-tabMenu>
</div>

